// removed by extract-text-webpack-plugin
module.exports = {"outer_wrapper":"src-components-FeaturedStory----FeaturedStory-module---outer_wrapper---2MggW","row":"src-components-FeaturedStory----FeaturedStory-module---row---2QA8b","featured_image":"src-components-FeaturedStory----FeaturedStory-module---featured_image---2Q20W","featured_post":"src-components-FeaturedStory----FeaturedStory-module---featured_post---1JR7Q","featured_post_category":"src-components-FeaturedStory----FeaturedStory-module---featured_post_category---1yH1R","read_more":"src-components-FeaturedStory----FeaturedStory-module---read_more---26Y1o"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FeaturedStory/FeaturedStory.module.scss
// module id = 794
// module chunks = 176293843571754